import React, { useState } from 'react';
import { Button, Input, Space, Typography } from 'antd';

const { Text } = Typography;

interface AgentSetupProps {
  onComplete: (clienteId?: number) => void;
}

const AgentSetup: React.FC<AgentSetupProps> = ({ onComplete }) => {
  const [clienteIdInput, setClienteIdInput] = useState('');

  const handleStart = () => {
    const parsed = parseInt(clienteIdInput.trim(), 10);
    const clienteId = isNaN(parsed) ? undefined : parsed;
    onComplete(clienteId);
  };

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <div>
        <Text strong>ID del cliente</Text>
        <br />
        <Text type="secondary" style={{ fontSize: 12 }}>
          Opcional. Si no lo sabes, déjalo vacío y menciona el cliente en la
          conversación.
        </Text>
      </div>
      <Input
        placeholder="Ej: 1042"
        value={clienteIdInput}
        onChange={(e) => setClienteIdInput(e.target.value)}
        onPressEnter={handleStart}
        style={{ maxWidth: 240 }}
        autoFocus
      />
      <Button type="primary" onClick={handleStart}>
        Iniciar registro
      </Button>
    </Space>
  );
};

export default AgentSetup;
